<template>
  <div>
    <PlatformSl
      ref="platform"
      :bridge="bridge"
      :localStoragePrefix="localStoragePrefix"
      :buttons="buttons"
      :outputs="outputs"
      :uarts="uarts"
      :leds="leds"
      :languages="languages"
      :vbusSpecifications="vbusSpecifications"
      displayType="X19320"
      @initialized="platformInitialized"
    ></PlatformSl>
  </div>
</template>

<script>
import { BasicPlatformWasiBridge } from '@/bridges/BasicPlatformWasiBridge';

import PlatformSl from '@/device-platforms/PlatformSl.vue';

const SpecificationFile = require('resol-vbus/src/specification-file');
const Specification = require('resol-vbus/src/specification');

export default {
  props: [
    'localStoragePrefix',
  ],

  components: {
    PlatformSl,
  },

  data: () => ({
    label: 'RESOL DeltaSol SLL 6_1.00',
    wasmUrl:'/ResolDeltaSolSll_6_1d00.wasm',
    wasmModule: null,
    bridge: null,
    vbusSpecifications: [],

    buttons: [
      { platformIndex: 0,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S1', }, // Pt1000
      { platformIndex: 1,conversion: 'resistorPt1000Temperature', value: null, initialValue: 52.3, name: 'S2', }, // Pt1000
      { platformIndex: 2,conversion: 'resistorPt1000Temperature', value: null, initialValue: 62.3, name: 'S3', }, // Pt1000
      { platformIndex: 3,conversion: 'resistorPt1000Temperature', value: null, initialValue: 72.3, name: 'S4', }, // Pt1000
      { platformIndex: 4,conversion: 'rawFrequency', conversions: ['rawFrequency', 'rawFrequency'], value: null, initialValue: 0.1, name: 'S5', },
      { platformIndex: 5,conversion: 'rawFrequency', conversions: ['rawFrequency', 'rawFrequency'], value: null, initialValue: 0.1, name: 'S6', },
      { platformIndex: 6,conversion: 'rawFrequency', conversions: ['rawFrequency', 'rawFrequency'], value: null, initialValue: 0.1, name: 'S7', },
      { platformIndex: 7,conversion: 'rawFrequency', conversions: ['rawFrequency', 'rawFrequency'], value: null, initialValue: 0.1, name: 'S8', },
      { platformIndex: 8,conversion: 'rawFrequency', conversions: ['rawFrequency', 'rawFrequency'], value: null, initialValue: 0.1, name: 'S9', },
      { platformIndex: 9,conversion: 'rawFrequency', conversions: ['rawFrequency', 'rawFrequency'], value: null, initialValue: 0.1, name: 'SA', },
//      { platformIndex: 4,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S5', }, // Pt1000
//      { platformIndex: 5,conversion: 'voltageGaTemperature', value: null, initialValue: 12.3, name: 'S17', }, // GFA
//      { platformIndex: 6,conversion: 'voltageRpsPressure', value: null, initialValue: 2.3, name: 'S17', }, // GFA
//      { platformIndex: 7,conversion: 'voltageGaTemperature', value: null, initialValue: 12.3, name: 'S18', }, // GFA
//      { platformIndex: 8,conversion: 'voltageRpsPressure', value: null, initialValue: 2.3, name: 'S18', }, // GFA
//      { platformIndex: 9,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S13', }, // Pt1000 / V40
    ],
    outputs: [
      { name: 'R1', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'R2', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'R3', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'R4', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'A1', conversion: 'dutycyclePercent', value: null }, // PWM / 0-10V
      { name: 'A2', conversion: 'dutycyclePercent', value: null }, // PWM / 0-10V
    ],

    leds: [
        { state: null }
    ],

    uarts: [
      { name: 'UART0', kind: 'VBus', label: 'GP' },
      { name: 'UART1', kind: 'VBus', label: 'DDS' },
    ],

    languages: [
      { value: 0, text: 'Deutsch', short: 'de' },
      { value: 1, text: 'English', short: 'en' },
    ],
  }),

  created() {
  },

  mounted() {
  },

  methods: {
    async prepareDevice() {
      const response = await fetch(this.wasmUrl);
      const wasmArrayBuffer = await response.arrayBuffer();
      // console.log(wasmArrayBuffer);

      this.wasmModule = await WebAssembly.compile(wasmArrayBuffer);
      // console.log(this.wasmModule);

      this.bridge = new BasicPlatformWasiBridge(this.wasmModule);
      await this.bridge.instantiate();

      this.$refs.platform.prepareBridgeable();

      const vsfResponse = await fetch('/vbus_specification.vsf');
      const vsfArrayBuffer = await vsfResponse.arrayBuffer();
      const vsfBuffer = Buffer.from(vsfArrayBuffer);
      const specificationFile = new SpecificationFile(vsfBuffer);
      const specification = new Specification({ specificationFile });
      this.vbusSpecifications.push(specification);
    },

    startDevice() {
      this.bridge.start();
    },

    restartDevice() {},

    platformInitialized() {
    },
  },
};
</script>

<style>

</style>
